<template>
  <v-row justify="center">
    <v-dialog :value="newClientModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Agregar Cliente</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  v-model="newClientData.nombre"
                  label="Nombre*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  outlined
                  v-model="newClientData.apellido"
                  label="Apellido*"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="7">
                <v-text-field
                  append-icon="mdi-text-short"
                  v-model="newClientData.email"
                  label="Email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="5">
                <v-text-field
                  append-icon="mdi-text-short"
                  v-model="newClientData.telefono"
                  label="Telefono"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  append-icon="mdi-text-short"
                  v-model="newClientData.direccion"
                  label="Dirección"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="newClientData.status"
                  :items="clientStatusTypes"
                  label="Status*"
                  required
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="ncDateMenu"
                  v-model="ncDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="newDate"
                      label="Fecha de nacimiento"
                      hint="año - mes - día"
                      persistent-hint
                      prepend-icon="mdi-calendar-clock"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newDate"
                    no-title
                    @input="ncDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-show="alertAlreadyExists">
              <v-snackbar
                v-model="alertAlreadyExists"
                :multi-line="true"
                absolute>
                Un cliente con ese nombre ya existe!

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="alertAlreadyExists = false">
                    Ok
                  </v-btn>
                </template>
              </v-snackbar>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template item.action="{ item }">
            <v-btn color="blue darken-1" text @click="closeCreateDialog">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="saveNewClientData">Save</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// import * as Utils from "../services/utils";
import { mapActions, mapGetters } from "vuex";
// const {saveNew} = api.services.clientesService; 

export default {
  name: "NuevoClienteModal",
  data() {
    return {
      alreadyExists: false,
      ncDateMenu: false,
      newDate: null,
      newClient: {
        nombre: "",
        apellido: "",
        email: "",
        telefono: "",
        direccion: "",
        fecha_nacimiento: "",
        status: "Turista",
      },
      clientStatusTypes: [
        "Turista",
        "Usuario",
        "Cliente",
        "Frecuente",
        "Preferente",
        "VIP",
      ],
    };
  },
  computed: {
    ...mapGetters(["newClientModal"]),
    alertAlreadyExists:{
      get: function(){
        return this.alreadyExists;
      },
      set: function(clientExists) {
        this.alreadyExists = clientExists;
      }
    },
    newClientData: {
      get: function () {
        return this.newClient;
      },
      set: function (data) {
        this.newClient = data;
      },
    },
    newClientIsValid() {
      const validName =
        this.newClient.nombre === null
          ? false
          : this.newClient.nombre === ""
          ? false
          : true;
      const validApellido =
        this.newClient.apellido === null
          ? false
          : this.newClient.apellido === ""
          ? false
          : true;
      return validName && validApellido;
    },
  },
  watch: {
    newDate(){
      this.newClientData.fecha_nacimiento = this.newDate;
    }
  },
  methods: {
    ...mapActions(['toggleNewClientModal', 'notifyNewClientAdded', 'addNewDemoCliente']),
    saveNewCliente(clienteData){
      return this.addNewDemoCliente(clienteData);
    },
    saveNewClientData() {
      if (this.newClientIsValid) {
        // const info = this.saveNewCliente(this.newClientData);
        this.saveNewCliente(this.newClientData).then(info=>{
          if (info) {
            const {clientID} = info;
            this.resetNewClient();
            this.notifyNewClientAdded(clientID);
            this.closeCreateDialog();
          }
          else{
            // alert("Un cliente con ese nombre ya existe!");
            this.alertAlreadyExists = true;
            // this.resetNewClient();
          }
        });
      } 
      else { 
        const errorMsg = "client is not valid!";
        alert(errorMsg)
        console.error(errorMsg);
      }
    },
    closeCreateDialog() {
      this.resetNewClient();
      this.toggleNewClientModal(false);
    },
    resetNewClient() {
      this.newClientData = {
        nombre: "",
        apellido: "",
        email: "",
        telefono: "",
        direccion: "",
        fecha_nacimiento: "",
        status: "Turista"
      };

      this.newDate = new Date().toISOString().substr(0, 10);
    },
  },
};
</script>